export default __webpack_public_path__ + "static/media/image-16.ea1a43ff.webp";